'use client'

import React from 'react'
import { cx } from 'utils/cx'

import style from './LinkListGridItem.module.scss'
import texts from 'fukku/styles/texts.module.scss'

export interface LinkListGridItemProps<T> {
	readonly id?: string
	readonly title: string
	readonly linkAttributes: Omit<T, 'children'>
	readonly linkAs?: React.ComponentType<T>
	readonly className?: string
	readonly icon?: JSX.Element
	readonly onClick?: (event: React.MouseEvent) => void
	readonly 'data-testid'?: string
}

export function LinkListGridItem<T>(props: LinkListGridItemProps<T>) {
	const {
		id,
		title,
		icon,
		linkAttributes,
		className,
		linkAs: LinkComponent = 'a',
		'data-testid': dataTestId,
		onClick = () => {},
	} = props

	return (
		<li id={id} className={cx(style.link, className)} data-testid={dataTestId}>
			<LinkComponent
				className={style.body}
				onClick={onClick}
				{...(linkAttributes as T)}
			>
				{icon}
				<p className={cx(style.title, texts.bodyM)}>{title}</p>
			</LinkComponent>
		</li>
	)
}

export default LinkListGridItem
